import AbstractStorage from './AbstractStorage';

class LocalStorage extends AbstractStorage {
  static get<T = string>(key: string): T | null {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  static set<T>(key: string, value: T): void {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }

  static clear(): void {
    localStorage.clear();
  }

  static getKeys(): string[] {
    return Object.keys(localStorage);
  }
}

export {LocalStorage};
